import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithAuthAndEnvelope } from "./baseQuery"

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithAuthAndEnvelope,
  tagTypes: [
    "Auth",
    "Dashboard",
    "Player",
    "Wallet",
    "Table",
    "Tournament",
    "Promotion",
    "Support",
    "Report",
    "Setting",
    "MissingDomain",
  ],
  endpoints: () => ({}),
})
